export const getBlockCreationObject = (data) => {
  let objectTemp = {
    name: data.name,
    jurisdiction_id: data?.jurisdiction_id,
  };

  return objectTemp;
};

export const getBlockUpdatenObject = (data) => {
  let objectTemp = {
    name: data.name,
    jurisdiction_id: data?.jurisdiction_id,
  };

  return objectTemp;
};
